import { takeLatest, put, call } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  BOOKMARK_DOCUMENTS_GET,
  BOOKMARK_COURSES_GET,
  BOOKMARK_SET,
  BOOKMARK_MODULES_GET,
  BOOKMARK_EVENTS_GET,
} from '../actions/bookmarks';
import courselist from '../../api/courselist';
import documents from '../../api/documents';

function* bookmarkCoursesGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(
      courselist.getCoursesList,
      {
        ...completeFilters,
        typology: 'course',
        is_module: false,
        bookmarked: true,
      }
    );
    yield put({
      type: BOOKMARK_COURSES_GET._SUCCESS,
      data,
      pager,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > bookmarks > bookmarkCoursesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* bookmarkCoursesGetWatch() {
  yield takeLatest(BOOKMARK_COURSES_GET._REQUEST, bookmarkCoursesGet);
}

function* bookmarkModulesGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(
      courselist.getCoursesList,
      {
        ...completeFilters,
        is_module: true,
        bookmarked: true,
      }
    );
    yield put({
      type: BOOKMARK_MODULES_GET._SUCCESS,
      data,
      pager,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > bookmarks > bookmarkModulesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* bookmarkModulesGetWatch() {
  yield takeLatest(BOOKMARK_MODULES_GET._REQUEST, bookmarkModulesGet);
}

function* bookmarkEventsGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(
      courselist.getCoursesList,
      {
        ...completeFilters,
        typology: 'event',
        is_module: false,
        bookmarked: true,
      }
    );
    yield put({
      type: BOOKMARK_EVENTS_GET._SUCCESS,
      data,
      pager,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > bookmarks > bookmarkEventsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* bookmarkEventsGetWatch() {
  yield takeLatest(BOOKMARK_EVENTS_GET._REQUEST, bookmarkEventsGet);
}

function* bookmarkDocumentsGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data, pager } = {} } = yield call(
      documents.documentsListGet,
      {
        filters: {
          ...filters,
          bookmarked: true,
        },
      }
    );
    yield put({
      type: BOOKMARK_DOCUMENTS_GET._SUCCESS,
      data,
      pager,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > bookmarks > bookmarkDocumentsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* bookmarkDocumentsGetWatch() {
  yield takeLatest(BOOKMARK_DOCUMENTS_GET._REQUEST, bookmarkDocumentsGet);
}

function* bookmarkSet({ id, action, item_type }) {
  if (id) {
    try {
      if (item_type === 'course') {
        yield call(courselist.setBookmark, id, action);
      } else if (item_type === 'document') {
        yield call(documents.setBookmark, id, action);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('sagas > bookmarks > bookmarkSet', err);
    }
  }
}

function* bookmarkSetWatch() {
  yield takeLatest(BOOKMARK_SET._REQUEST, bookmarkSet);
}
export default [
  bookmarkCoursesGetWatch(),
  bookmarkModulesGetWatch(),
  bookmarkEventsGetWatch(),
  bookmarkDocumentsGetWatch(),
  bookmarkSetWatch(),
];
